import ArrayClass from './ArrayClass';
import i18n from 'src/i18n';

class SelectClass {
  constructor(scope) {
    this.scope = scope;
  }

  selectAllFromSelect(model, array_data, scope = null) {
    let is_string = typeof model === 'string' || model instanceof String;
    let if_validation = is_string
      ? eval('this.scope.' + model + '.includes(0)')
      : model.includes(0);

    if (if_validation) {
      let maped = array_data.map((item) => {
        return item.id;
      });

      if (is_string) {
        eval(
          'this.scope.' +
            model +
            ' = ' +
            '[' +
            ArrayClass.joinSeparateByParam(maped) +
            ']'
        );
        let before_filered = eval('this.scope.' + model);
        eval(
          'this.scope.' +
            model +
            ' = ' +
            '[' +
            ArrayClass.joinSeparateByParam(before_filered) +
            ']' +
            '.filter((item) => { return item != 0 })'
        );
      } else {
        model = maped.filter((item) => {
          return Number(item) != 0;
        });
        if (scope) {
          scope.row.businesses_id = model;
        }
      }
    }
  }

  selectAllFromSelectSensors(model, array_data, scope = null) {
    let is_string = typeof model === 'string' || model instanceof String;
    let if_validation = is_string
      ? eval('this.scope.' + model + '.includes(-1)')
      : model.includes(-1);

    if (if_validation) {
      let maped = array_data.map((item) => {
        return item.code;
      });

      if (is_string) {
        this.scope.payload.sensor_codes = [...maped].filter(
          (item) => item != -1
        );
      } else {
        model = maped.filter((item) => {
          return item != -1;
        });
        if (scope) {
          scope.row.businesses_id = model;
        }
      }
    }
  }

  /**
   * Selecciona todos los elementos de una lista de los lotes de un select.
   *
   * @param {Event} $event: el evento de cambio de la lista de selección.
   * @param {string} model: el nombre del modelo que se actualizará.
   * @param {object[]} arrayData: la fuente de datos de la lista de selección.
   */
  selectAllFromSelectLots($event, model, arrayData) {
    const isString = typeof model === 'string' || model instanceof String;
    const text1 = i18n.t('cla.utilselects.text1');

    if ($event.includes(text1)) {
      const filteredData = arrayData
        .filter((item) => item.name !== text1)
        .map((item) => `'${item.name}'`);

      if (isString) {
        const filteredString = '[' + filteredData.join(',') + ']';
        eval(`this.scope.${model} = ${filteredString}`);
      }
    }
  }

  /**
   * Manejador de cambio de selects para asignarlo al modelo en la data,
   * según los parámetros del método
   * @param {object} data: un objeto que contiene el nombre y las propiedades de selección
   */
  handleChangeSelected(data) {
    this.scope.$set(this.scope.model, data.name, data.selects);
  }

  /**
   * Actualiza las empresas seleccionados en el modelo en base a los datos
   * seleccionados en el componente de selección de empresas
   * @param {object} data: un objeto que contiene los identificadores
   * de asociaciones, identificadores de empresas y nombres de las empresas.
   */
  updateSelectedBusinesses(data) {
    const bsSelected = data.associations_ids.concat(data.businesses_ids);
    try {
      this.scope.$set(this.scope.model, 'businesses_id', bsSelected);
      this.scope.$set(this.scope.model, 'businesses_names', data.names);
    } catch (error) {
      console.info(error);
    }
  }

  /**
   * Gestiona la selección masiva ("Seleccionar todos") en inputs de tipo select.
   * Caso especial de Entrenamiento o Actividad (Reportes HIP Crecer) 
   * 
   * Si detecta el valor -1 (típicamente 'Todos'), mapea los datos del arreglo 
   * proporcionado y actualiza el modelo o el scope correspondiente.
   *
   * @param {string|Array} model - El nombre de la propiedad en el scope (string) o la referencia al arreglo de datos.
   * @param {Array} array_data - La lista de opciones disponibles para seleccionar.
   * @param {Object|null} [scope=null] - Referencia opcional al objeto de fila para actualizaciones directas.
   */
  selectAllFromSelectActivities(model, array_data, scope = null) {
    let is_string = typeof model === 'string' || model instanceof String;
    let if_validation = is_string
      ? eval('this.scope.' + model + '.includes(-1)')
      : model.includes(-1);

    if (if_validation) {
      let mapped = array_data.map((item) => {
        return item.id === -1 ? -1 : item.name;
      });

      if (is_string) {
        eval(
          'this.scope.' +
            model +
            ' = ' +
            JSON.stringify(mapped.filter((item) => item != -1))
        );
      } else {
        model = mapped.filter((item) => item != -1);
        if (scope) {
          scope.row.businesses_id = model;
        }
      }
    }
  }
}

export default SelectClass;
